function cov_zjteypsrj() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Refresh.tsx";
  var hash = "5fa1ed5e0fe75a8d687f6915507f2a5db6379690";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Refresh.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 47
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "5fa1ed5e0fe75a8d687f6915507f2a5db6379690"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_zjteypsrj = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_zjteypsrj();
var Icon = (cov_zjteypsrj().s[0]++, {
  name: 'refresh',
  svg: "<path d=\"M11.109 6.41925L10.6116 6.83381C10.0812 7.27576 10.0096 8.06397 10.4515 8.59432C10.8935 9.12466 11.6817 9.19632 12.212 8.75436L15.2046 6.26056C15.9 5.68106 15.9 4.61301 15.2046 4.03351L12.212 1.53969C11.6817 1.09774 10.8935 1.16939 10.4515 1.69974C10.0096 2.23008 10.0812 3.01829 10.6116 3.46025L11.142 3.90228C6.44006 4.30727 2.75 8.2523 2.75 13.0592C2.75 18.1353 6.86503 22.2504 11.9412 22.2504C17.0173 22.2504 21.1324 18.1353 21.1324 13.0592C21.1324 12.3688 20.5727 11.8092 19.8824 11.8092C19.192 11.8092 18.6324 12.3688 18.6324 13.0592C18.6324 16.7546 15.6366 19.7504 11.9412 19.7504C8.24574 19.7504 5.25 16.7546 5.25 13.0592C5.25 9.64554 7.80629 6.82895 11.109 6.41925Z\" fill=\"currentColor\"/>"
});
export default Icon;